import { Airport } from "shared/types/airportsTypes";

export const topInternationalDestinationsData: Airport[] = [
  {
    description: "Madri - Barajas (MAD), Espanha",
    name: "Madri",
    code: "MAD",
  },
  {
    description: "Miami - Miami Intl (MIA), Estados Unidos",
    name: "Miami",
    code: "MIA",
  },
  {
    description: "Roma - Fiumicino (FCO), Itália",
    name: "Roma",
    code: "FCO",
  },
  {
    description: "Amsterdam - Schiphol (AMS), Holanda",
    name: "Amsterdam",
    code: "AMS",
  },
  {
    description: "Nova York - John F Kennedy (JFK), Estados Unidos",
    name: "Nova York",
    code: "JFK",
  },
];
